import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap/dist/js/bootstrap.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CameraModal from "./CameraModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate, faCamera, faFloppyDisk, faImages, faPills, faTrash, faTrashAlt, faXmark } from '@fortawesome/free-solid-svg-icons';
import PatientDetails from './PatientDetails';

export default function DoctorPrescription() {

  //********************** Variables Declare *****************************************-
  const API_URL = "http://localhost:5002/";
  const baseUrl = "https://mount.serveis.in/api/";

  const [pos, setPos] = useState({ x: 0, y: 0, scale: 1 });
  const [isModalOpen, setModalOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [capturedImages, setCapturedImages] = useState([]);
  const [isDesktop, setIsDesktop] = useState(true);

  const [doctorPrescription, setDoctorPrescription] = useState({
    Id: 0,
    Drugs: '',
    PatientId: '',
    VisitId: '',
    UserId: ''
  });

  const [patientDetails, setPatientDetails] = useState({
    id: 0,
    clientId: 0,
    code: '',
    name: '',
    age: null,
    gender: '',
    mobileNo: '',
    bloodGroup: '',
    height: null,
    weight: null,
    bmi: null,
    emailId: '',
    address: '',
    pincode: null,
    aadharNo: '',
    status: true,
    isDeleted: false,
    createdBy: '',
    createdDate: '',
    lastModifiedBy: '',
    lastModifiedDate: '',

    // Items: '',
    // Disease: '',
    // MedicineTaken: '',
    // VisitId: '',
    // UserId: ''
  });


  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Simple check for mobile devices
    const isMobile = /android|iphone|ipad|mobile/i.test(userAgent);
    setIsDesktop(!isMobile);

    const uhid = localStorage.getItem('uhid');
    const lastUhid = localStorage.getItem('lastUhid');

    if (uhid && uhid === lastUhid) {
      // Load from localStorage to avoid API call
      const savedPatient = localStorage.getItem('patientDetails');
      if (savedPatient) {
        setPatientDetails(JSON.parse(savedPatient));
        return; // exit early, no API call
      }
    }
    if (uhid) {
      loadPatientByUhid(uhid, setPatientDetails);
    }
  }, []);

  const styles = {
    gallery: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
    },
    thumbnail: {
      width: '50px',
      height: '40px',
      cursor: 'pointer',
      objectFit: 'cover',
      border: '2px solid #ccc',
      borderRadius: '5px',
    },
    modalOverlay: {
      position: 'absolute',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999,
    },
    modalContent: {
      background: 'white',
      padding: '0px',
      borderRadius: '10px',
      textAlign: 'center',
    },
    modalImage: {
      maxWidth: '40vw',
      maxHeight: '30vh',
      borderRadius: '5px',
    },

    gallery: {
      display: 'flex',
      gap: '15px',
      flexWrap: 'wrap',
    },
    card: {
      position: 'relative',
      display: 'block',
      flexDirection: 'column',
      alignItems: 'center',
      border: '1px solid #ddd',
      padding: '10px',
      borderRadius: '8px',
    },
    gallery: {
      display: 'flex',
      gap: '15px',
      flexWrap: 'wrap',
    },
    imageWrapper: {
      position: 'relative',
      display: 'inline-block',
    },
    thumbnail: {
      width: '80px',
      height: '60px',
      objectFit: 'cover',
      borderRadius: '8px',
    },
    deleteBtn: {
      position: 'absolute',
      top: '3px',
      right: '3px',
      backgroundColor: '#df2323',
      color: 'white',
      border: 'none',
      borderRadius: '30%',
      width: '22px',
      height: '20px',
      cursor: 'pointer',
      fontSize: '8px',
      lineHeight: '20px',
      textAlign: 'center',
    },
  };

  //****************************** Upload file images ***************************


  const loadPatientByUhid = async (uhid, setPatientDetails) => {
    try {
      if (!uhid) return;

      const token = localStorage.getItem('access_token');

      const response = await axios.get(`${baseUrl}PatientMaster/GetByUhid/${uhid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data && response.data.length > 0) {
        const patientData = response.data[0];
        setPatientDetails(patientData);

        // Save to localStorage
        localStorage.setItem('lastUhid', uhid);
        localStorage.setItem('patientDetails', JSON.stringify(patientData));
      } else {
        setPatientDetails({});
      }
    } catch (error) {
      if (error.response) {
        console.log("Response Error:", error.response.data);
        console.log("Status:", error.response.status);
      } else {
        console.log("Error:", error.message);
      }
    }
  };


  const deleteImage = (indexToDelete) => {
    setPreviews(previews.filter((_, index) => index !== indexToDelete));
    setCapturedImages(capturedImages.filter((_, index) => index !== indexToDelete));
    setImages(images.filter((_, index) => index !== indexToDelete));
  };

  const handleImageChange = (e) => {
    debugger;
    const files = Array.from(e.target.files);
    //setImages(files);

    files.map((file, index) => (
      setImages((prevImages) => [...prevImages, file])
    ))


    const previewList = files.map(file => URL.createObjectURL(file));
    //setPreviews(previewList);
    //setPreviews((prevImages) => [...prevImages, previewList]);
    previewList.map((file, index) => (
      setPreviews((prevImages) => [...prevImages, file])
    ))

  };

  // Handle upload
  const handleUpload = async () => {
    debugger;
    const formData = new FormData();
    formData.append('patientid', doctorPrescription.PatientId);
    formData.append('visitid', doctorPrescription.VisitId);
    formData.append('userid', doctorPrescription.UserId);
    images.forEach((image) => {
      formData.append('images', image);
    });

    try {
      await axios.post(API_URL + 'uploads', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      //alert('Upload success!');
    } catch (err) {
      console.error(err);
      alert('Upload failed.');
    }
  };

  //-******************************** Upload Camera *************************

  const handleOpenPopup = () => {
    setModalOpen(true)
  }

  const handleCapture = (newImage) => {
    setCapturedImages((prevImages) => [...prevImages, newImage]);
    setPreviews((prevImages) => [...prevImages, newImage]);
  };


  const uploadCameraImage = async () => {
    const PatientId = doctorPrescription.PatientId; // You can dynamically set this
    const VisitId = doctorPrescription.VisitId;
    const UserId = doctorPrescription.UserId;

    // fetch(API_URL+'cameraupload', {
    //   method: 'POST',
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify({ image: capturedImages, patientId:PatientId,visitId:VisitId,userId:UserId })
    // })
    // .then(res => res.json())
    // .then(data => console.log('Upload Success:', data))
    // .catch(err => console.error('Upload Error:', err));

    try {
      const formData = new FormData();
      formData.append('patientid', doctorPrescription.PatientId);
      formData.append('visitid', doctorPrescription.VisitId);
      formData.append('userid', doctorPrescription.UserId);
      capturedImages.forEach((image, index) => {
        const blob = dataURItoBlob(image);
        formData.append("images", blob, `image${index}.jpg`);
      });

      try {
        await axios.post(API_URL + 'cameraupload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        //alert('Upload success!');
      } catch (err) {
        console.error(err);
        alert('Camera Upload failed.');
      }
    }
    catch (error) {
      console.error('Upload error:', error);
    }

  };

  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  };

  // -****************************** Save and Update Data ***************************

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDoctorPrescription({ ...doctorPrescription, [name]: value });
  }
  const handleAddPrecsription = async () => {
    try {
      debugger;
      if (doctorPrescription.Id > 0) {
        axios.put(`${API_URL + "api/UpdateDoctorPrescription"}/${doctorPrescription.Id}`, doctorPrescription, { timeout: 10000 })
          .then(response => {
            let countImage = 0
            images.forEach((image) => {
              countImage++;
            });
            if (countImage > 0) {
              handleUpload();
            }

            if (capturedImages != null) {
              uploadCameraImage();
            }

            // let dvImage = document.getElementById("dvImage");
            // dvImage.style.display = 'none'
            //setCapturedImages([]);
            toast.success("Doctor Prescription updated successfully");
            setDoctorPrescription({
              Id: 0,
              Drugs: '',
              PatientId: '',
              VisitId: '',
              UserId: ''
            });
          }).catch(err => {
            console.log(err);
          });
      }
      else {
        axios.post(API_URL + "api/AddDoctorPrescription", doctorPrescription, { timeout: 10000 })
          .then(response => {
            let countImage = 0
            images.forEach((image) => {
              countImage++;
            });
            if (countImage > 0) {
              handleUpload();
            }

            if (capturedImages != null) {
              uploadCameraImage();
            }

            // let dvImage = document.getElementById("dvImage");
            // dvImage.style.display = 'none'
            //setCapturedImages([]);
            toast.success("Doctor Prescription saved successfully");
            setDoctorPrescription({
              Id: 0,
              Drugs: '',
              PatientId: '',
              VisitId: '',
              UserId: ''
            });
          }).catch(err => {
            console.log(err);
          });
      }


    }
    catch (error) {
      console.log(error);
    }
  }


  //************************** Get Data by Id *******************************
  const handleDoctorClick = async (visitid) => {
    try {
      const response = await axios.get(`${API_URL + "api/getDoctorPrescriptionById"}/${visitid}`);
      console.log(response);
      setDoctorPrescription(response.data.empData);
      handleGetImages();
    }
    catch (error) {
      console.log(error);
    }
  }

  //*****************Get All Images By Id********************* */
  const handleGetImages = async () => {
    try {
      const response = await axios.get(`${API_URL + "api/ImagesById"}/${doctorPrescription.PatientId}/${doctorPrescription.VisitId}`);
      console.log(response);
      debugger;
      setImageUrl(response.data.empData);

    }
    catch (error) {
      console.log(error);
    }
  }
  //*************************Reset All Data *****************************/
  const handleReset = async () => {
    // document.getElementById("dvImage").style.display = 'none'
    // document.getElementById("dvPrev").style.display="none";
    setCapturedImages([]);
    setPreviews([]);
    setImages([]);
    setImageUrl([]);
    setDoctorPrescription({
      Id: 0,
      Drugs: '',
      PatientId: '',
      VisitId: '',
      UserId: ''
    });
  }


  //*******************************Design Part***************************** */

  return (
    <div className="container">
      <form>
        <ToastContainer position="bottom-left" />

        <PatientDetails
          patientDetails={patientDetails}
          loadPatientByUhid={(uhid) => loadPatientByUhid(uhid)}
        />

        <div style={{ height: "10px" }}></div>

        <div className="mb-3">
          {/* <label style={{ cursor: 'pointer' }}>
            <i className="fa-solid fa-pills" style={{fontSize:"25px"}}></i>  
          </label> */}
          <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "25px" }} icon={faPills} />
          <label className="form-label fw-bold">Drugs/Dosages</label>
          <textarea className="form-control" name="Drugs"
            value={doctorPrescription.Drugs}
            onChange={handleInputChange}
            rows="3"></textarea>
        </div>

        {/* Upload Prescription Section */}
        <div className="mb-3">
          <input type="file" id="fileInput" style={{ display: 'none' }} className="form-control mb-2" multiple accept="image/*" onChange={handleImageChange} />
          {/* <div id="dvImage" style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
            {previews.map((src, index) => (
              <img key={index} src={src} alt="preview" width="100" />
            ))}
          </div> */}


        </div>

        <button type='button' id="btnCamera" style={{ display: 'none' }} onClick={handleOpenPopup} className="btn btn-primary btn-sm px-2 py-1" >
          Open Camera  </button>


        <label htmlFor="fileInput" style={{ cursor: 'pointer' }}>
          <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "25px" }} icon={faImages} />
        </label>
        &nbsp;&nbsp;&nbsp;
        {isDesktop && (
          <label htmlFor="btnCamera" style={{ cursor: 'pointer' }}>
            <FontAwesomeIcon
              icon={faCamera}
              style={{ fontSize: "25px", cursor: 'pointer' }}
            />
          </label>
        )}

        {/* <CameraModal onCapture={(img) => setCapturedImage(img)} isOpen={isModalOpen} onClose={() => setModalOpen(false)} /> */}
        <CameraModal onCapture={handleCapture} isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
        {/* {capturedImage && <ImagePreview image={capturedImage} />} */}
        {/* <div className="mt-4">   
        <img src={capturedImage} id='imgCamera' alt="Captured"  style={{width:"25%"}} className={capturedImage==null ? 'hidden' : 'border rounded w-full max-w-sm'} />
      </div> */}


        {/* <div>
           {images.map((img, idx) => (
            <img key={idx} src={img} alt={`Captured ${idx}`} width={100} />
          ))}
        </div>*/}

        <div id="dvImage" style={styles.gallery}>
          {previews.map((src, index) => (
            <div key={index} style={styles.imageWrapper}>
              <img key={index} src={src} alt="preview" style={styles.thumbnail} onClick={() => setSelectedImage(src)} />
              <button type='button' onClick={() => deleteImage(index)} style={styles.deleteBtn}>
                <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "12px" }} icon={faTrashAlt} />
              </button>


            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedImage && (
          <div style={styles.modalOverlay} onClick={() => setSelectedImage(null)}>
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <img src={selectedImage} alt="Zoomed" style={styles.modalImage} />
              <button id="pClose" type="button" style={{ display: 'none' }} onClick={() => setSelectedImage(null)}>Close</button>
              <label htmlFor="pClose" style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "25px" }} icon={faXmark} />
              </label>
            </div>
          </div>
        )}



        {/* Action Buttons */}
        <div className="d-flex justify-content-end gap-2">
          <button type='button' id="btnRefresh" style={{ display: 'none' }} className="btn btn-danger btn-sm px-2 py-1" onClick={handleReset} >Reset</button>
          <button type='button' id="btnSave" style={{ display: 'none' }} className="btn btn-primary btn-sm px-2 py-1" onClick={handleAddPrecsription}>
            Save
          </button>


          <label htmlFor="btnSave" style={{ cursor: 'pointer', fontSize: "15px" }} className="btn btn-success btn-sm px-2 py-1">
            {/* <i className="fa-solid fa-floppy-disk" style={{fontSize:"25px"}}></i>   */}
            <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "16px" }} icon={faFloppyDisk} /> &nbsp;Save
          </label>

          <label htmlFor="btnRefresh" style={{ cursor: 'pointer', fontSize: "15px" }} className="btn btn-danger btn-sm px-2 py-1">
            {/* <i className="fa-solid fa-arrows-rotate" style={{fontSize:"25px"}}></i>   */}
            <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "16px" }} icon={faArrowsRotate} />&nbsp;Clear
          </label>
        </div>
        {/* <canvas id='dvCapPreview'
          ref={canvasRefPrev}
          width="150"
          height="150"
        ></canvas> */}


        <div id="dvPrev" className="image-gallery">
          {imageUrl.map(image => (
            <img key={image.Id} src={image.FileServerURL} alt={`Image${image.Id}`} />
          ))}
        </div>

      </form>
    </div>
  );
}
